'use strict'

const ky = require('ky/umd').default

const create = ({ appLogger, baseUrl, metaSiteId, instance }) => {
  const SERVICE_ENDPOINT = `${baseUrl}/_api/wix-code-telemetry-registry-public/v1/sites/${metaSiteId}/telemetry`
  const CONFIGURATION_URL = `${SERVICE_ENDPOINT}/runtime-configuration`
  const fallbackConfiguration = { hasSinks: false }

  const fetchConfiguration = () =>
    ky
      .get(CONFIGURATION_URL, {
        headers: {
          Authorization: instance
        }
      })
      .json()
      .catch(e => {
        if (e.response && e.response.status >= 500) {
          appLogger.error(e)
        } else {
          appLogger.warn(e)
        }

        return fallbackConfiguration
      })

  return {
    fetchConfiguration
  }
}

module.exports.create = create
